import axios from 'axios';
import { Paginated } from '../../common/types';
import { CurrentCycleContent } from '../../common/model/dto/current-cycle-content';
import { ADMIN_CURRENT_CYCLE_CONTENTS_ROUTE } from '../../api/backend';

export const loadCurrentCycleContents = async (query: string) => {
  const { data } = await axios.get<Paginated<CurrentCycleContent>>(
    `${ADMIN_CURRENT_CYCLE_CONTENTS_ROUTE}?${query}`
  );

  return data;
};

export const getCurrentCycleContentById = async (id: string) => {
  const { data } = await axios.get<CurrentCycleContent>(
    `${ADMIN_CURRENT_CYCLE_CONTENTS_ROUTE}/${id}`
  );

  return data;
};

export const updateCurrentCycleContentById = async (
  currentCycleContentId: string,
  updates: Partial<CurrentCycleContent>
) => {
  await axios.patch<CurrentCycleContent>(
    `${ADMIN_CURRENT_CYCLE_CONTENTS_ROUTE}/${currentCycleContentId}`,
    updates
  );
};
